import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { postSession } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sid = m ? decodeURIComponent(m[1]) : null;
    window.history.replaceState(null, "", window.location.pathname);

    if (!sid) {
      navigate("/login", { replace: true });
      return;
    }
    postSession(sid)
      .then((u) => {
        setUser(u);
        navigate("/dashboard", { replace: true });
      })
      .catch((err) => {
        const d = err?.response?.data?.detail;
        const contact = (d && d.contact) || "";
        const email = (d && d.email) || "";
        navigate("/no-access", { replace: true, state: { contact, email } });
      });
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 gap-3">
      <Loader2 className="w-8 h-8 text-guinda animate-spin" />
      <p className="text-sm text-slate-500">Verificando acceso...</p>
    </div>
  );
}
